import React from 'react';
import styles from '../AiDialog.module.css';

export function ContextHint({ hasCategory, hasCuisine, productCategory, cuisineType }) {
  if (!hasCategory || !hasCuisine) {
    return (
      <div className={styles.hintWarning}>
        For better AI results, please select{' '}
        {!hasCategory && !hasCuisine
          ? 'both product category and cuisine'
          : !hasCategory
            ? 'a product category'
            : 'a cuisine'}{' '}
        in the product form. They will be included automatically in the prompt.
      </div>
    );
  }

  return (
    <span className={styles.hintInfo}>
      Using category &quot;{productCategory}&quot; and cuisine &quot;{cuisineType}&quot; in this
      prompt for more accurate suggestions.
    </span>
  );
}
